import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";

import FormTextbox from "../components/FormTextbox";
import FormSelect from "../components/FormSelect";
import EntryButtons from "../components/EntryButtons";
import EntryContainer from "./EntryContainer";

import {
  futureYearOptions,
  countryOptions,
  stateOptions,
  jobFieldOptions
} from "../schema";
import {validRequiredString} from "../utils";

const validationSchema = yup.object().shape({
  jobField: yup.string().required("Job field is required"),
  employer: validRequiredString("Employer"),
  jobTitle: validRequiredString("Job Title"),
  country: yup.string().required("Country is required"),
  state: yup.string().required("State is required"),
  from: yup.string().required("From is required"),
  to: yup
    .string()
    .required("To is required")
    .test("to-valid", "Inalid end year", function(value) {
      return this.parent.from <= value;
    })
});

const EntryCareer = ({
  values,
  onSubmit,
  onDelete,
  onCancel,
  noDelete,
  ...props
}) => {
  const handleSubmit = (values, actions) => {
    onSubmit(values, actions);
  };
  return (
    <EntryContainer {...props}>
      <Formik
        initialValues={values}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {formik => (
          <Form noValidate onSubmit={formik.handleSubmit}>
            <FormTextbox
              formik={formik}
              controlId="jobTitle"
              label="Job Title"
              required
            />
            <FormTextbox
              formik={formik}
              controlId="employer"
              label="Employer"
              required
            />
            <FormSelect
              formik={formik}
              controlId="jobField"
              label="Job Field"
              options={jobFieldOptions}
              required
            />
            <Row>
              <FormSelect
                as={Col}
                formik={formik}
                controlId="country"
                label="Country"
                options={countryOptions}
                onChange={() => formik.setFieldValue("state", "")}
                required
              />
              <FormSelect
                as={Col}
                formik={formik}
                controlId="state"
                label="State"
                options={stateOptions[formik.values.country]}
                required
              />
            </Row>
            <Row>
              <FormSelect
                as={Col}
                formik={formik}
                controlId="from"
                label="From"
                options={futureYearOptions}
                required
              />
              <FormSelect
                as={Col}
                formik={formik}
                controlId="to"
                label="To"
                options={futureYearOptions}
                required
              />
            </Row>
            <EntryButtons
              onDelete={onDelete}
              onCancel={onCancel}
              loading={formik.isSubmitting}
              noDelete={noDelete}
            />
          </Form>
        )}
      </Formik>
    </EntryContainer>
  );
};

export default EntryCareer;
